export const COLORS = { THEME_COLOR: "#7878b9", THEME_COLO_hOVER: "#5a5abe" };

export const colorArray = [
  '#2A78D6', // 1. Blue
  '#EB6834', // 2. Orange
  '#1BAF7A', // 3. Green
  '#EDA100', // 4. Yellow
  '#8B5E3C', // 9. Brown
  '#4A3AA7', // 6. Violet
  '#6B7280',  // 10. Gray
  '#E87BA4', // 5. Pink
  '#008300', // 8. Dark green
  '#E34948', // 7. Red
];

export const colorArray_claude =  [
  '#2A78D6',
  '#EB6834',
  '#1BAF7A',
  '#EDA100',
  '#E87BA4',
  '#4A3AA7',
  '#00B0BE',
  '#7A9A01',
  '#8B5E3C',
  '#6B7280'
];
// export const colorArray = [
//   "#6350ff",
//   "#259ad2",
//   "#257c71",
//   "#14d351",
//   "#999933",
//   "#a4762a",
//   "#cc6677",
//   "#dc58a6",
//   "#AA4499",
//   "#0072B2",
//   "#E69F00",
//   "#56B4E9",
//   "#009E73",
//   "#F0E442",
//   "#D55E00",
// ];
